// icons/boat.svg

export const BoatIconV2 = (props) => (
  <svg
    className={props.className}
    width="35"
    height="28"
    viewBox="0 0 35 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 12.225L30.4625 17.1124C29.4 19.6624 27.275 23.4874 23.45 24.7624H11.55C7.5125 23.4874 5.3875 19.6624 4.5375 17.1124L17.5 12.225ZM17.5 8.82495L0.5 15.2C0.5 15.2 2.625 25.8249 11.125 27.9499H23.875C32.375 25.8249 34.5 15.2 34.5 15.2L17.5 8.82495Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7 5.9563C9.4552 5.9563 8.46875 6.94275 8.46875 8.18755V15.2001H5.28125V8.18755C5.28125 5.18234 7.6948 2.7688 10.7 2.7688H24.3C27.3052 2.7688 29.7188 5.18234 29.7188 8.18755V14.9875H26.5312V8.18755C26.5312 6.94275 25.5448 5.9563 24.3 5.9563H10.7Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7812 0.856201H21.2188V6.1687H13.7812V0.856201Z"
      fill="#34363E"
    />
  </svg>
);
